import { SUMMARY_SEPARATOR } from '../useToolOptionsSummary';
import { ModifierCountText } from './constraintParts';
import { useActiveModifierCount } from './useActiveModifierCount';

/**
 * The count of the drawing modifiers in force that apply, and of those on
 * but applying to nothing, for a tool options summary line: led by the
 * separator when `afterValues`. Renders nothing while no modifier is on.
 */
export default function ModifierCountSummary({
    afterValues,
}: {
    /** Values precede the count on the line. */
    afterValues: boolean;
}) {
    const count = useActiveModifierCount();
    if (count.active === 0 && count.inactive === 0) {
        return null;
    }
    return (
        <>
            {afterValues && SUMMARY_SEPARATOR}
            <ModifierCountText count={count} />
        </>
    );
}
